import { twMerge } from "tailwind-merge";

interface SkeletonProps {
  className?: string;
  variant?: "text" | "block" | "circle";
}

// Content-shaped loading placeholder — replaces bare spinners for moments
// where the eventual layout is already known (e.g. a card about to populate
// with fetched data).
const Skeleton = ({ className, variant = "block" }: SkeletonProps) => {
  return (
    <div
      className={twMerge([
        "animate-pulse bg-dark-12",
        variant === "text" && "h-3.5 rounded-full",
        variant === "block" && "rounded-control",
        variant === "circle" && "rounded-full",
        className,
      ])}
    />
  );
};

export default Skeleton;
